
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiUrl from "../../environment/Api";
import axios from "axios";
import { toast } from "react-toastify";

function Invoice_email() {
    const navigate = useNavigate();

    // State to hold email summary, email address, and selected file
    const [addData, setAddData] = useState({
        email_summary: "",
        email: "",
        // invoiceFile: null, // State for storing the selected file
    });

    // Handle file selection (updating the state when a file is selected)
    const handleFileChange = (e) => {
        setAddData({
            ...addData,
            invoiceFile: e.target.files[0], // Store the first selected file
        });
    };

    // Handle the form submission
    const handleNewButtonClick = async (e) => {
        e.preventDefault();

        // Create FormData object to send both text and file data
        const formData = new FormData();
        formData.append("email_summary", addData.email_summary);
        formData.append("email", addData.email);
        // formData.append("invoiceFile", addData.invoiceFile); // Add the file to the form data

        try {
            // Send data to the server using Axios
            const response = await axios.post(apiUrl + "/invoice_mail", formData, {
                headers: {
                    "Content-Type": "multipart/form-data", // Specify that it's a multipart form
                },
            });

            // If the request is successful, display a success message
            console.log("Email sent:", response);
            toast.success("Email sent successfully!");
            
            // Reset the form state after submission
            setAddData({
                email_summary: "",
                email: "",
                // invoiceFile: null, // Reset the file input
            });

        } catch (error) {
            // Handle errors and display an error message
            console.error("Error sending email:", error.message);
            toast.error("Failed to send email. Please try again.");
        }
    };

    return (
        <div>
            <div className="col-lg-12">
                <div className="card">
                    <div className="row pt-4">
                        <div className="col-lg-1"></div>
                        <div className="col-lg-6">
                            <label>Text:</label>
                            <div className="floating-label">
                                <textarea
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter the summary"
                                    value={addData.email_summary}
                                    onChange={(e) =>
                                        setAddData({ ...addData, email_summary: e.target.value })
                                    }
                                    required
                                />
                                <label className={addData.email_summary ? "filled" : ""}></label>
                            </div>
                        </div>
                        <div className="col-lg-5 pt-4">
                            <div className="floating-label">
                                <input
                                    className="form-control"
                                    type="email"
                                    placeholder="Enter the email"
                                    value={addData.email}
                                    onChange={(e) =>
                                        setAddData({ ...addData, email: e.target.value })
                                    }
                                    required
                                />
                                <label className={addData.email ? "filled" : ""}></label>
                            </div>
                        </div>
                    </div>

                    {/* File upload input for the PDF invoice */}
                    {/* <div className="row pt-4">
                        <div className="col-lg-6">
                            <label>Upload Invoice (PDF):</label>
                            <div className="floating-label">
                                <input
                                    type="file"
                                    className="form-control"
                                    accept=".pdf" // Restrict file selection to PDFs only
                                    onChange={handleFileChange} // Handle file change event
                                    required // Make the file selection required
                                />
                                <label className={addData.invoiceFile ? "filled" : ""}></label>
                            </div>
                        </div>
                    </div> */}

                    {/* Action buttons */}
                    <div className="container row pt-4">
                        <div className="col-lg-1"></div>
                        <div className="col-lg-1 mx-2">
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => navigate("/invoice")} // Navigate to invoice page
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="col-lg-2 mx-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => navigate("/Addinvoice")} // Navigate to Add Invoice page
                            >
                                Back
                            </button>
                        </div>

                        <div className="col-lg-5"></div>
                        <div className="col-lg-2">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleNewButtonClick} // Trigger the email sending process
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Invoice_email;
